"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BuyerService = void 0;
const tslib_1 = require("tslib");
const Base_1 = require("../Base");
const apiRoutes_1 = require("../../utils/apiRoutes");
class BuyerService extends Base_1.BaseService {
    resolveCountry() {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const response = yield this.request({
                url: (0, apiRoutes_1.resolveCountryUrl)(),
                method: 'get',
            });
            return response.country;
        });
    }
}
exports.BuyerService = BuyerService;
//# sourceMappingURL=index.js.map